import Konva from 'konva';
import React from 'react';
import { Group, Text } from 'react-konva';
import { TextShape as ITextShape } from '../../../../types';
import { mergeRefs } from '../../../../utils/mergeRef';
import { getTextProps } from '../../helpers/getTextProps';
import { ShapeCommonProps } from '../../types';
import { useShape } from '../ShapeContext/useShape';
import { TextEditor } from './TextShapeEditor';
import { FiberProvider } from '@gettactic/helpers/src/dom/useContextBridge';

export const TextShape = React.forwardRef<
  React.ElementRef<typeof Text>,
  ShapeCommonProps
>((props, ref) => {
  const {
    isHovered,
    setIsEditing,
    shape,
    isInSelection,
    onUpdate,
    isGroupChild,
    disabled
  } = useShape();

  const { highlightShape, highlightShapeData, ...commonProps } = props;

  const textShape = shape as ITextShape;
  const shapeRef = React.useRef<React.ElementRef<typeof Text>>(null);

  //const [editorEnabled, setEditorEnabled] = React.useState(false);
  const textRef = React.useRef<Konva.Text>(null);

  const editorEnabled = !!highlightShapeData;

  const text = textShape.text;

  const onChange = (newText: string) => {
    onUpdate({ text: newText });
  };

  const handleTextDblClick = () => {
    if (textShape.type === 'text' && !isGroupChild && !shape.locked) {
      highlightShape?.({
        shape: textShape,
        targetId: textShape.id
      });
    }
  };

  const textProps = {
    x: editorEnabled ? 0 : commonProps.x,
    y: editorEnabled ? 0 : commonProps.y,
    text,
    fontSize: textShape.fontSize,
    fontFamily: textShape.fontFamily,
    width: textShape.width,
    height: textShape.height,
    stroke:
      !textShape.locked && (isHovered || isInSelection)
        ? '#000000'
        : 'transparent',
    strokeWidth: 0.5,
    opacity: textShape.locked ? 0.5 : 1,
    onDblClick: handleTextDblClick,
    visible: !editorEnabled
  };

  if (!editorEnabled) {
    return (
      <Text
        {...commonProps}
        {...textProps}
        ref={mergeRefs([shapeRef, ref, textRef])}
        {...getTextProps(textShape)}
        visible={!editorEnabled}
      />
    );
  }

  return (
    <FiberProvider>
      <Group x={commonProps.x} y={commonProps.y}>
        <Text
          {...commonProps}
          {...textProps}
          ref={mergeRefs([shapeRef, ref, textRef])}
          {...getTextProps(textShape)}
          visible={!editorEnabled}
        />
        {editorEnabled && (
          <Group>
            <TextEditor
              value={text}
              textNodeRef={textRef}
              onChange={onChange}
              onBlur={() => {
                highlightShape?.(null);
                commonProps.onMouseLeave({} as never);
              }}
              onMouseLeave={commonProps.onMouseLeave}
            />
          </Group>
        )}
      </Group>
    </FiberProvider>
  );
});
